<template>
  <div class="container-withdraw-account" :class="[packageName]">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px; background-color: #f7f6f9;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.WithdrawalAccount.k038') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <!-- 图标 -->
      <div class="account-tit">
        <div class="account-img">
          <img :src="icon | imgPath" alt="" />
        </div>
        <span class="line"></span>
        <div class="account-name">{{ withdrawalMethod }}</div>
      </div>

      <!-- 提现名 -->
      <div class="select">
        <span>{{ $t('lang.WithdrawalAccount.k026') }}</span>
        <div class="country">
          <img :src="locaFlag | imgPath" alt="" />
          <div class="account-name">{{ locaCode }}</div>
        </div>
      </div>

      <div class="select">
        <span>{{ $t('lang.WithdrawalAccount.k028') }}</span>
        <input style="color: #333" type="text" :placeholder="$t('lang.WithdrawalAccount.k032')" v-model.trim="accountName" />
      </div>

      <div class="select">
        <span type="text">{{ $t('lang.BaseCommon.k099') }} (TRC20/BEP20)</span>
        <div class="select-account">
          <div class="TRC20-box">
            <input
              maxlength="42"
              type="text"
              :placeholder="$t('lang.BaseCommon.k099')"
              v-model.trim="accountId"
              @input="onlyNumOrLetter($event, 'accountId')"
            />
          </div>
        </div>

        <!-- 提示 -->
        <!-- prettier-ignore -->
        <div class="tipTRC20-a">
          *<a href="https://www.binance.com/support/faq/detail/115003764971">{{ $t('lang.WithdrawalAccount.k025') }}</a>
        </div>
      </div>

      <!-- 保存按钮 -->
      <div class="save-btn" :class="{ 'save-btn-act': this.saveFlag() }" @click="handleSave">
        {{ cfgId ? $t('lang.BaseCommon.k008') : $t('lang.WithdrawalAccount.k036') }}
      </div>
    </div>
  </div>
</template>

<script>
import { apiBindWithdrawAccount, apiEditWithdrawAccount } from '@/api/imee.js'

import _debounce from 'lodash/debounce'
import baseMixin from '../base.mixin.js'

export default {
  mixins: [baseMixin],
  data() {
    return {}
  },
  methods: {
    // 保存
    handleSave: _debounce(
      function () {
        // 去掉空格
        const strAccountId = `${this.accountId}`
        this.accountId = strAccountId.replace(/\s*/g, '')

        const data = {
          accountId: this.accountId,
          accountName: this.accountName,
        }

        // 判断emoji表情
        if (this.hasEmojiCharacter(this.accountName)) {
          this.accountName = ''
          this.$client.showToast(this.$t('lang.WithdrawalAccount.k027'))
          return
        }

        if (this.withdrawalMethod === 'USDT(TRC20/BEP20)') {
          // accountAddress
          this.accountAddress = this.accountId

          if (![34, 42].includes(this.accountAddress.length)) {
            this.accountAddress = ''
            this.$client.showToast(this.$t('lang.WithdrawalAccount.k006'))
            return
          }

          // 地址开头校验
          if (!/^(T|0x).*/.test(this.accountAddress)) {
            this.accountAddress = ''
            this.$client.showToast(this.$t('lang.WithdrawalAccount.k005'))
            return
          }

          // TRC20字符集校验
          if (this.accountAddress.length === 34 && /^T/.test(this.accountAddress) && !/^[A-Za-z0-9]+$/.test(this.accountAddress)) {
            this.accountAddress = ''
            this.$client.showToast(this.$t('lang.WithdrawalAccount.k011'))
            return
          }

          // BEP20字符集校验
          if (this.accountAddress.length === 42 && /^0x/.test(this.accountAddress) && !/^[0-9a-f]+$/i.test(this.accountAddress.slice(2))) {
            this.accountAddress = ''
            this.$client.showToast(this.$t('lang.WithdrawalAccount.k003'))
            return
          }

          data.accountAddress = this.accountAddress
        }

        // edit
        if (this.cfgId) {
          apiEditWithdrawAccount(data, this.cfgId).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
        // add
        else {
          data.withdrawalMethod = this.withdrawalMethod
          apiBindWithdrawAccount(data).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
      },
      3000,
      {
        leading: true,
        trailing: false,
      }
    ),
    // 保存校验
    saveFlag() {
      if (this.accountId && this.accountName) {
        return true
      }

      return false
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../base.scss';
</style>
